var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.91663C8.13 1.91663 5 4.91621 5 8.62496C5 13.6562 12 21.0833 12 21.0833C12 21.0833 19 13.6562 19 8.62496C19 4.91621 15.87 1.91663 12 1.91663ZM7 8.62496C7 5.97996 9.24 3.83329 12 3.83329C14.76 3.83329 17 5.97996 17 8.62496C17 11.385 14.12 15.5154 12 18.0933C9.92 15.5345 7 11.3562 7 8.62496ZM9.5 8.62496C9.5 7.30178 10.6193 6.22913 12 6.22913C12.8932 6.22913 13.7185 6.68577 14.1651 7.42704C14.6116 8.16832 14.6116 9.0816 14.1651 9.82288C13.7185 10.5641 12.8932 11.0208 12 11.0208C10.6193 11.0208 9.5 9.94814 9.5 8.62496Z",
    fill: "#375B6B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.03ab9520c17723202d672377eff11611.svg";
export { ForwardRef as ReactComponent };